import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import InvitedMembersDialog from "@/components/shared/dialogs/Schedule_Dialog/Invited_Members_Dialog";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMultipleUsers,
  fetchMultipleUsersAsync,
  selectIsLoadingMultiple,
} from "@/store/redux/slices/user/user_slice";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";

const AssignedMembers = ({ speakers = [] }) => {
  const dispatch = useDispatch();
  const users = useSelector(selectMultipleUsers);
  const isLoading = useSelector(selectIsLoadingMultiple);

  useEffect(() => {
    if (speakers.length > 0) {
      dispatch(fetchMultipleUsersAsync(speakers));
    }
  }, [dispatch, speakers]);

  const assignedMembers = users.map((user) => ({
    id: user._id,
    name: user.fullname,
    email: user.email,
    avatar: user.profileImage || null,
    role: "Speaker",
  }));

  const [isInvitedMembersDialogVisible, setIsInvitedMembersDialogVisible] =
    useState(false);

  const moreMenu = {
    items: [
      {
        key: "edit",
        label: "Edit Role",
      },
      {
        key: "remove",
        label: "Remove Member",
        danger: true,
      },
    ],
  };

  return (
    <>
      <div className="mt-8 bg-white border p-4 sm:p-6 w-full rounded-lg overflow-hidden">
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="flex justify-between items-center mb-4 sm:mb-6">
              <h3 className="text-bold text-darkGrey">Assigned Members</h3>
              {/* <Button 
                type="link" 
                className="text-primary font-bold p-0"
                onClick={() => setIsInvitedMembersDialogVisible(true)}    
              >
                Add More
              </Button> */}
            </div>

            <div className="space-y-4">
              {assignedMembers.map((member) => (
                <div
                  key={member.id}
                  className="flex items-center justify-between border-b border-gray-100 pb-4 last:border-b-0 last:pb-0">
                  <div className="flex items-center gap-2 sm:gap-4 overflow-hidden flex-1">
                    <Avatar
                      src={member.avatar}
                      size={40}
                      shape="circle"
                      className="flex-shrink-0"
                    />
                    <div className="flex text-left flex-col overflow-hidden">
                      <span className="text-regular font-bold text-black truncate">
                        {member.name}
                      </span>
                      <span className="text-small text-lightGrey truncate">
                        {member.email}
                      </span>
                    </div>
                    <span className="text-primary text-small font-bold ml-4 sm:ml-4 flex-shrink-0">
                      {member.role}
                    </span>
                  </div>

                  <Dropdown
                    menu={moreMenu}
                    placement="bottomRight"
                    trigger={["click"]}>
                    <div onClick={(e) => e.preventDefault()}>
                      <CustomMoreOptions
                        variant="filled"
                        orientation="vertical"
                        color="black"
                        size="small"
                      />
                    </div>
                  </Dropdown>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <InvitedMembersDialog
        isVisible={isInvitedMembersDialogVisible}
        onClose={() => setIsInvitedMembersDialogVisible(false)}
      />
    </>
  );
};

AssignedMembers.propTypes = {
  speakers: PropTypes.array,
};

export default AssignedMembers;
